import Vue from 'vue';
import Vuex from 'vuex';
import createCache from "vuex-cache";
import createPersistedState from 'vuex-persistedstate';
import modules from './modules';
import { clearLocalStorageWhenNewVersion } from './helper';

Vue.use(Vuex);

const { localStorage } = window;
const localStorageKey = 'vuex';

const store = new Vuex.Store({
  modules,
  state: {
    storeVersion: '0.0.1'
  },
  mutations: {},
  plugins: [
    createCache({ timeout: 30000 }),
    clearLocalStorageWhenNewVersion(localStorage, localStorageKey),
    createPersistedState({ storage: localStorage, key: localStorageKey, paths: ['storeVersion'] }),
  ]
});

export default store;
